import React, { Component } from "react";
import "../styles/App.css";
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from 'react-html-parser';
import '../styles/reactGridStyles.css';
import '../styles/reactResizableStyles.css';

const AutoWidthGridLayout = WidthProvider(GridLayout);

class Content extends Component {
  render() {
    if (this.props.showResume) {
      return null;
    }

    return (
      <div className="contentContainer">
        <AutoWidthGridLayout
          className="layout"
          layout={this.props.layout}
          cols={this.props.columns}
          rowHeight={300}
          margin={[16, 16]}
          containerPadding={[0, 0]}
        >
          {this.props.posts.map((post) => (
            <div
              className="post"
              key={post.id}
              onClick={(e) => this.props.getPost(post.id, e)}
            >
              {post.featured_image && (
                <div className="post-featured-image">
                  <img 
                    src={post.featured_image} 
                    alt={post.title}
                    loading="lazy"
                  />
                </div>
              )}
              <div className="title">
                <span className="icon">
                  <FontAwesomeIcon icon={post.icon}></FontAwesomeIcon>
                </span>
                {ReactHtmlParser(post.title)}&nbsp;
                <span className="timestamp">{post.post_age}</span>
              </div>
              {this.props.processBody(post)}
            </div>
          ))}
        </AutoWidthGridLayout>
      </div>
    );
  }
}

export default Content;
